import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify();
